import { IReaderStationStatus } from "../models/IReaderStatus";
import { axiosInstance } from "./ServiceConstants";
import { CancelToken } from "axios";

class MonitoringService {

    async getReadersStatus(cancelToken?: CancelToken): Promise<IReaderStationStatus[]> {
        const readersStatusResponse = await axiosInstance.get<IReaderStationStatus[]>("api/health/readers", { cancelToken });
        return readersStatusResponse.data;
    }

    
}

const MonitoringServiceInstance = new MonitoringService();

export default MonitoringServiceInstance;